import React, { createContext, ReactNode } from 'react';

export interface IVoiceContext {}

export const VoiceContext = createContext<IVoiceContext>(null!);

interface VoiceProviderProps {
  children: ReactNode;
}

export function VoiceProvider({ children }: VoiceProviderProps) {
  return <VoiceContext.Provider value={{}}>{children}</VoiceContext.Provider>;
}
